"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranularityTabs = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sortBy_1 = tslib_1.__importDefault(require("lodash/sortBy"));
var Tabs_1 = require("../Tabs/Tabs");
var i18n_1 = require("../constants/i18n");
var granularityOrders = {
    "GDC.time.date": 0,
    "GDC.time.week_us": 1,
    "GDC.time.month": 2,
    "GDC.time.quarter": 3,
    "GDC.time.year": 4,
};
var sortGranularities = function (granularities) {
    return sortBy_1.default(granularities, function (granularity) { return granularityOrders[granularity]; });
};
exports.GranularityTabs = function (_a) {
    var availableGranularities = _a.availableGranularities, onSelectedGranularityChange = _a.onSelectedGranularityChange, selectedGranularity = _a.selectedGranularity;
    return (react_1.default.createElement(Tabs_1.TabsWrapper, { className: "gd-relative-filter-form-granularity-tabs s-relative-filter-form-granularity-tabs" }, sortGranularities(availableGranularities).map(function (granularity) {
        var intlGranularity = i18n_1.granularityIntlCodes[granularity];
        return (react_1.default.createElement(Tabs_1.Tab, { key: granularity, selected: granularity === selectedGranularity, onClick: function () { return onSelectedGranularityChange(granularity); }, className: "s-granularity-" + intlGranularity },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filters.granularity." + intlGranularity + "s" })));
    })));
};
//# sourceMappingURL=GranularityTabs.js.map